var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"elevation-1"},[_c('h3',[_vm._v("Companies")]),_c('v-spacer'),_c('v-btn',{attrs:{"absolute":"","dark":"","fab":"","top":"","right":"","color":"teal"},on:{"click":_vm.add}},[_c('v-icon',[_vm._v("add")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }